module.exports = __webpack_public_path__ + "static/ilustracao-gestao-performance-f7d5936949f0146c7635ae5200661521.svg";